import React from "react";
import { useFilters } from "hooks/useStore";
import Dropdown from "components/dropdown";
import { sortOptions } from "utils/constants";

const Sorting = ({ handle, value }) => {
	const { changeSortBy } = useFilters(["changeSortBy"]);

	return (
		<div className="flex gap-2 text-sm md:text-base items-center">
			<p className="lg:block text-secondary">Sort by </p>
			<Dropdown
				Preview={() => <p className="pr-2">{sortOptions[value]}</p>}
				onChange={(e) => changeSortBy(handle, e.target.value)}
				className=""
				activeClass="!border-none"
				value={value}
				label="Sort By"
			>
				{Object.entries(sortOptions).map(([key, value]) => (
					<option key={key} value={key} aria-label={`Sort By ${value}`}>{value}</option>
				))}
			</Dropdown>
		</div>
	);
};

export default Sorting;